import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { FormMessage, IconName, Stack } from '@optimus-web/core';
import { TooltippedIcon } from '@mews-commander/ui';
import { RATE_KEY_FIELD_NAME } from './fieldNames';
import { getFieldDisabledConfig } from './helpers';
import { WithFieldsConfig } from './types';

export const RateKeyField = ({ fieldsConfig }: WithFieldsConfig) => {
    const isDisabled = getFieldDisabledConfig(RATE_KEY_FIELD_NAME, fieldsConfig);

    return (
        <Stack spacing="100" vertical>
            <FormInputField
                name={RATE_KEY_FIELD_NAME}
                label={<LocalizedText textKey={TextKey.RateKey} />}
                disabled={getFieldDisabledConfig(RATE_KEY_FIELD_NAME, fieldsConfig)}
                captionIconWithTooltip={
                    <TooltippedIcon size="small" value={IconName.Help} tooltip={TextKey.RateKeyHelperText} />
                }
                helper={<LocalizedText textKey={TextKey.RateKeyHelperText} />}
            />
            {isDisabled ? (
                <FormMessage>
                    <LocalizedText textKey={TextKey.SomeRatesAreFromSameEnterprise} />
                </FormMessage>
            ) : null}
        </Stack>
    );
};
